import { FieldCell } from 'common/components/table/cell-formatters/fieldCell';
import Blur from 'features/blur/blur';
import { FC, Fragment } from 'react';

const MapFieldRenderer: FC<{
  fieldsMap: { [key: string]: string } | Map<string, string>;
  contextKey: string;
}> = ({ fieldsMap, contextKey }) => {
  if (!fieldsMap) {
    return null;
  }

  const entries =
    fieldsMap instanceof Map
      ? [...fieldsMap.entries()]
      : Object.entries(fieldsMap);

  return (
    <div className="flex flex-col items-left flex-wrap my-1 truncate">
      {entries.map(([key, value], index) => {
        if (!value) {
          return null;
        }

        return (
          <Fragment key={`fields_col_${contextKey}_${index}`}>
            <Blur>
              <FieldCell identifier={key} value={value} />
            </Blur>
          </Fragment>
        );
      })}
    </div>
  );
};

export default MapFieldRenderer;
